import './Processing.css';

const Processing = () => {
  return (
    <div className='progress-4'>
      
    </div>
  )
}

export default Processing